import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CONTACT_INFO } from '../../constants';
import './FAQ.css';

interface FAQItem {
	id: number;
	questionKey: string;
	answerKey: string;
}

const FAQ_KEYS: FAQItem[] = [
	{ id: 1, questionKey: 'faq.q1', answerKey: 'faq.a1' },
	{ id: 2, questionKey: 'faq.q2', answerKey: 'faq.a2' },
	{ id: 3, questionKey: 'faq.q3', answerKey: 'faq.a3' },
	{ id: 4, questionKey: 'faq.q4', answerKey: 'faq.a4' },
	{ id: 5, questionKey: 'faq.q5', answerKey: 'faq.a5' },
	{ id: 6, questionKey: 'faq.q6', answerKey: 'faq.a6' },
];

/**
 * FAQ accordion component
 */
const FAQ: React.FC = () => {
	const { t } = useTranslation();
	const [openItem, setOpenItem] = useState<number | null>(null);

	const toggleItem = (id: number) => {
		setOpenItem(openItem === id ? null : id);
	};

	return (
		<section className="faq-section" id="faq">
			<div className="faq-container">
				<div className="faq-header">
					<h2>{t('faq.title')}</h2>
					<p>{t('faq.subtitle')}</p>
				</div>

				<div className="faq-list">
					{FAQ_KEYS.map((item) => (
						<div key={item.id} className="faq-item">
							<button
								className={`faq-question ${openItem === item.id ? 'active' : ''}`}
								onClick={() => toggleItem(item.id)}
								type="button"
								aria-expanded={openItem === item.id}
								aria-controls={`faq-answer-${item.id}`}
							>
								<span>{t(item.questionKey)}</span>
								<svg
									className={`faq-icon ${openItem === item.id ? 'rotated' : ''}`}
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									aria-hidden="true"
								>
									<path
										d="M6 9L12 15L18 9"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							</button>
							<div
								id={`faq-answer-${item.id}`}
								className={`faq-answer ${openItem === item.id ? 'open' : ''}`}
								role="region"
								aria-labelledby={`faq-question-${item.id}`}
							>
								<p>{t(item.answerKey)}</p>
							</div>
						</div>
					))}
				</div>

				<div className="faq-cta">
					<h3>{t('contact.subtitle')}</h3>
					<p>{t('contact.title')}</p>
					<div className="faq-contact-info">
						<div className="contact-item">
							<span className="contact-label">{t('contact.phone')}:</span>
							<span className="contact-value">{CONTACT_INFO.phone}</span>
						</div>
						<div className="contact-item">
							<span className="contact-label">{t('contact.email')}:</span>
							<span className="contact-value">{CONTACT_INFO.email}</span>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default FAQ;
